// Copyright (c) Docugami, Inc. All rights reserved.

import React from 'react';
import { IPanelStyles, Panel } from "@fluentui/react";
import styled from 'styled-components';
import { UserContent, UserTitle } from 'components/common/Fonts';
import alertsImage from 'assets/HomeAlerts.png';
import { NotificationsView, ReadSemantics } from './NotificationsView';
import { emptyColor, homeGray, primaryTheme } from 'components/shell/presentation/AppStyles';
import { DeepPartial } from 'redux';

const CenteredUserTitle = styled(UserTitle)`
    text-align: center;
    font-size: 26px;
    border-bottom: 1px solid ${emptyColor};
    padding-bottom: 20px;
    color: ${homeGray};
`;

const EmptyLabel = styled(UserContent)`
    color: ${homeGray};
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 20px;
`;

const EmptyContainer = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: column;
`;

const placeholderText = 'You have no notifications!';

interface NotificationsPanelProps {
    onClose: () => void;
    isShowing: boolean;
}

export const NotificationsPanel = (props: NotificationsPanelProps): JSX.Element => {
    const panelStyle: DeepPartial<IPanelStyles> = {
        main: {
            backgroundColor: primaryTheme.palette.white,
            top: "50px"
        },


        commands: {
            marginTop: "5px",
            ".root-226": {
                marginRight: "5px"
            }
        },

        scrollableContent: {
            span: {
                display: 'flex',
                flexDirection: 'column'
            }
        }
    };

    return (
        <Panel
            isOpen={props.isShowing}
            isLightDismiss={true}
            onDismiss={() => props.onClose()}
            onLightDismissClick={() => props.onClose()}
            styles={panelStyle}>
            <CenteredUserTitle>NOTIFICATIONS</CenteredUserTitle>
            <div style={{
                overflowX: "hidden",
                overflowY: "auto",
                height: "100%",
                display: "flex",
                flexDirection: "row",
                backgroundColor: primaryTheme.palette.white,
                width: '100%'
            }}>
                <NotificationsView filter={[]} readSemantics={ReadSemantics.OnClose} emptyView={<EmptyNotificationsView />} />
            </div>
        </Panel>);
}

const EmptyNotificationsView = (): JSX.Element => {
    return (
        <EmptyContainer>
            <EmptyLabel>{placeholderText}</EmptyLabel>
            <img src={alertsImage} alt='No Notifications' width='300px' />
        </EmptyContainer>
    );
}
